var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scale pt-4"},[_c('b-calendar',{staticClass:"cal",attrs:{"id":"ex-disabled-readonly","locale":"de","block":"","hide-header":true,"readonly":true,"today-variant":"danger","start-weekday":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }